import { render, staticRenderFns } from "./StockAlertListTop.vue?vue&type=template&id=35eff42e&"
import script from "./StockAlertListTop.vue?vue&type=script&lang=js&"
export * from "./StockAlertListTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports